import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fa-build/src/components/pages/home/courses/CoursePage.js");
